import React from "react";
import { IconPartyPopper } from "../../assets/icon/IconPartyPopper";
import styles from "./CardSupport.module.css";

const CardSupport = () => {
  const options = [
    {
      title: "Servicio al cliente",
      subtitle: "Contacto con el gerente",
      action: () => window.location.href = "/servicio-cliente"
    },
    {
      title: "Soporte técnico",
      subtitle: "Resuelve problemas rápidamente",
      action: () => window.location.href = "/soporte-tecnico"
    },
    {
      title: "Bot de autoservicio",
      subtitle: "Atención inmediata 24/7",
      action: () => window.location.href = "/bot-autoservicio"
    },
  ];

  return (
    <div className={`d-flex rounded-4 shadow-sm overflow-hidden ${styles.cardWallet}`}>
      <div className="d-flex align-items-center justify-content-center px-3" style={{ backgroundColor: "rgba(203, 230, 97, 1)" }}>
        <IconPartyPopper className="fs-2" />
      </div>

      <div className="flex-grow-1 p-4 text-white">
        <div className={styles.title}>Centro de Soporte</div>
        <div className={`mb-4 ${styles.subtitle}`}>Elige cómo quieres recibir ayuda</div>

        <div className="row g-3">
          {options.map((opt, idx) => (
            <div key={idx} className="col-12 col-md-4">
              <div
                className={`bg-light text-dark rounded-3 p-3 h-100 shadow-sm ${styles.optionCard}`}
                onClick={opt.action}
                style={{ cursor: "pointer" }}
              >
                <h6 className="fw-bold mb-1">{opt.title}</h6>
                <small className="text-muted">{opt.subtitle}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardSupport;
